export default {
  ARCHIVED: "archived",
  SHOOT_REQUESTED: "shoot_requested",
  SHOOT_CONFIRMED: "shoot_confirmed",
  IN_PROCESS: "in_process",
  PHOTOS_READY: "photos_ready",
  PUBLISHED: "published",
  NEW: "new",
  AWAITING_PAYMENT: "awaiting_payment",
  INACTIVE: "inactive",
};
